import { useFetcher } from '@remix-run/react';
import { useEffect, useState } from 'react';

import type { PublicationForm } from '~/interfaces/form';
import type { Publication } from '~/interfaces/publication';

interface DataResponse {
  isLoading: boolean;
  data: {
    form: PublicationForm;
    email: string;
    isPreview: boolean;
    publication: Publication;
  } | null;
}

interface Props {
  formId: string;
  email: string;
}

const usePostSubscribeForm = ({ formId, email }: Props): DataResponse => {
  const fetcher = useFetcher();
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!fetched && formId) {
      fetcher.load(`/forms/${formId}?email=${email}`);
      setFetched(true);
    }
  }, [fetcher, formId]);

  return {
    isLoading: fetcher.state === 'loading' || !fetcher?.data,
    data: fetcher?.data,
  };
};

export default usePostSubscribeForm;
